import styled, { css } from 'styled-components';
import { THEME } from '../../../themes';
import { Subtitle2Font } from '../../../themes/fonts';
import { RibbonPosition } from './PerfectRibbon';

const positionStyles = {
  'top-left': css`
    top: 35px;
    left: -50px;
    transform: rotate(-45deg);
  `,
  'top-right': css`
    top: 35px;
    right: -50px;
    transform: rotate(45deg);
  `,
  'bottom-left': css`
    bottom: 35px;
    left: -50px;
    transform: rotate(45deg);
  `,
  'bottom-right': css`
    bottom: 35px;
    right: -50px;
    transform: rotate(-45deg);
  `,
};

export const Ribbon = styled.div<{ $position: RibbonPosition }>`
  position: absolute;
  color: ${THEME.COLORS.PURE_WHITE};
  background-color: ${THEME.COLORS.SECONDARY};
  padding: ${THEME.SPACING.TINY} ${THEME.SPACING.MEDIUM};
  ${({ $position }) => positionStyles[$position]};
  ${Subtitle2Font};
  font-weight: bold;
  pointer-events: none;
  width: 200px;
  display: flex;
  justify-content: center;
`;
